export const TAB_ROUTES = ["/", "/calendar", "/explore", "/my-events", "/profile"] as const

export function isActive(path: string, pathname: string): boolean {
  return path === "/" ? pathname === "/" : pathname.startsWith(path)
}

export function isTabRoute(pathname: string): boolean {
  return (TAB_ROUTES as readonly string[]).includes(pathname)
}
